module.exports = "../images-mrinalini/swiper-next.png";